import {Component} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';

import {TGoogleAnalytic, Util} from "../../../app/util";

import {LogadoService} from '../../../providers/logado-service';
import {CONFIG} from "../../../app/config";
import {TAction} from "../../../app/enum";

import {DataService} from "../../../providers/data-service";
import {HotspotService} from "../../../providers/hotspot-service";

declare var google;



@Component({
    selector: 'page-showhour',
    templateUrl: 'showhour.html',
    providers: [HotspotService]
})

export class ShowhourPage {

    config: any;
    logado: any;

    hotspotList = [
        {HotspotID: 1998, Branded: {BrandedNome: 'Lili'}},
        {HotspotID: 1517, Branded: {BrandedNome: 'Vila 567'}},
        {HotspotID: 1303, Branded: {BrandedNome: 'Boteco Todos os Santos'}},
        {HotspotID: 2117, Branded: {BrandedNome: 'Praça'}},
    ];

    constructor(public util: Util, public navCtrl: NavController, public navParams: NavParams,
                public dataService: DataService,
                public logadoService: LogadoService,
                public hotspotService: HotspotService) {

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Showhour', '/showhour');

        this.load(true);

    }

    ionViewDidLoad() {

        document.title = 'Showhour';

    }

    showChart(index, graficoList?) {

        // var data = google.visualization.arrayToDataTable([
        //     ['Year', 'Publico', 'Consumo', 'Cliente'],
        //     ['06',  10000,      400, 800],
        //     ['07',  660,       1120, 2000],
        //     ['08',  660,       1120, 2000],
        //   ]);

        var data = google.visualization.arrayToDataTable(graficoList);
  
          var options = {
            title: this.hotspotList[index].Branded.BrandedNome,
            curveType: 'function',
            legend: { position: 'bottom' }
          };
  
          var chart = new google.visualization.LineChart(document.getElementById('curve_chart' + index));
  
          chart.draw(data, options);

    }

    load(isFirst = true) {

        let onList = (hotspotID, consumos) => {

            let graficoList = [['Hora', 'Consumo', 'Publico', 'Cliente']];
            consumos.forEach(line => {
                let graficoLine = [];
                graficoLine.push((line.ConsumoHora <= 9 ? '0' : '') + line.ConsumoHora + '' + (line.ConsumoPart == 30 ? ':30' : 'h') + '');
                graficoLine.push(line.ConsumoCash);
                graficoLine.push(line.ComandaQtde);
                graficoLine.push(100);
                graficoList.push(graficoLine);
            });
            this.showChart(hotspotID, graficoList);

        }

        let loadqtd = 0;
        let loading = this.util.loadingDots();
        if (isFirst) loading.present();

        this.hotspotList.forEach((hotspot, index) => {

            this.util.monitorDesk(true, 'DESK-Started', hotspot.HotspotID, '', TAction.acHora)
            .finally(() => {
                loadqtd++;
                if (loadqtd == this.hotspotList.length) {
                    if (isFirst) loading.dismiss();
                    //Se veio zero Math.max 10.000 = 10s
                    let timeout = 1 * 60 * 1000;
                    setTimeout(() => this.load(false), timeout);
                }
            })
            .subscribe(data => {

                onList(index, data.Consumos);

            }, erro => {

            });

        })

    }

    dismiss() {

        this.navCtrl.pop();

    }

}



// WEBPACK FOOTER //
// ./src/pages/show/showhour/showhour.ts